<template>
<div :class="{'home-container': isAcephalousPage }">
  <div v-if="isAcephalousPage" class="content">
    <router-view/>
  </div>
  <div v-else class="content" :style="{'display: grid':!($route.name === 'Index' && platform === 'web')}">
    <gjw-space-header v-if="this.isLogin && this.isLogin === true" class="home-header" />
    <div class="container">
      <Menu v-if="isShowMenu"/>
      <router-view :class="{'main-container':!detailRouteNames.includes($route.name)}"/>
    </div>
  </div>
  <guide-for-new v-if="showGuide" />
  <rate-feedback @close="closeFeedbackDialog" />
<!--  <ad-poster />-->
</div>
</template>

<script>
import Config from '@/config'
import GjwSpaceHeader from '@/components/business/GjwSpaceHeader.vue'
import Menu from '@/components/layout/Menu.vue'
import GuideForNew from '@/components/layout/GuideForNew.vue'
import RateFeedback from '@/views/RateFeedback.vue'
// import AdPoster from '@/components/business/AdPoster.vue'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Utils from '@/core/utils'
const basicsRoute = ['Index', 'InviteLink', 'Signin', 'FileModelShareView']
export default {
  mixins: [checkLoginMixin],
  name: 'Home',
  components: {
    GjwSpaceHeader,
    Menu,
    GuideForNew,
    RateFeedback,
    // AdPoster,
  },
  data() {
    return {
      detailRouteNames: ['ComponentDetail', 'ModuleDetail'],
      isLogin: null,
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      user: 'user/user',
      spacesDetail: 'classifySpace/spacesDetail'
    }),
    getSpaceName() {
      return this.spacesDetail.name
    },
    isShowMenu() {
      return this.isLogin && this.isLogin === true && !this.$route.meta.hideMenu
    },
    isAcephalousPage() {
      const pages = [
        'InviteLink', 'Signin', 'Downgrade',
        'FileModelShareView', 'FederationPlanPreview', 'FederationPlanView', 'FederationPlanShareView',
        'IntegratedModelView', 'IntegratedModelShareView',
      ]
      return pages.includes(this.$route.name)
    },
    showGuide() {
      return !this.$route.meta.hideGuide
    },
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler(newVal) {
        this.init()
        if (basicsRoute.includes(newVal)) {
          document.title = Config.projectName
        } else {
          const specialPages = ['FileModelView', 'FederationPlanView', 'FederationPlanPreview', 'FileModelShareView', 'IntegratedModelView', 'IntegratedModelShareView']
          if (specialPages.includes(this.$route.name)) { return }
          const spaceName = sessionStorage.getItem('spaceName')
          if (spaceName) {
            document.title = spaceName
          } else {
            setTimeout(() => {
              document.title = sessionStorage.getItem('spaceName') || Config.projectName
            }, 1000)
          }
        }
      }
    }
  },
  async created() {
    if (this.$route.meta.ignoreLogin) { return }
    const isLogin = await this.checkLogin(null)
    if (isLogin) {
      const res = await this.$api.user.userInfoRefresh()
      res && await this.loadUserInfo()
    }
    await this.getPermissionGroups()
  },
  mounted() {
    if (this.platform !== 'web') {
      // web端的埋点由各云盘入口处理，此处只需处理插件端的埋点
      this.$tracks({ event: 'openSpaceURL' })
    }
  },
  methods: {
    ...mapMutations({
      setFeedbackDialogVisible: 'feedback/setFeedbackDialogVisible',
      showPoster: 'adPoster/SHOW_POSTER'
    }),
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
      getPermissionGroups: 'common/getPermissionGroups'
    }),
    async init() {
      if (this.$route.meta.ignoreLogin) {
        // 免登陆页面，可直接打开
        return
      }
      const isLogin = await this.checkLogin(null)
      this.isLogin = isLogin
      if (!isLogin) {
        if (!this.$route.name || this.$route.name !== 'Signin') {
          this.$router.push({ name: 'Signin', query: { to: Utils.getUrlQuery('to') }}).catch()
          return
        }
      }
      if (isLogin) {
        if (this.$route.name === 'Signin') {
          const to = Utils.getUrlQuery('to')
          if (to) {
            if (['OpenSpaceList'].includes(to)) {
              this.$router.push({ name: to, query: { to }}).catch()
            } else {
              this.$router.push({ name: to }).catch()
            }
          } else {
            this.$router.push({ name: 'Index' }).catch()
          }
        }
      }
    },
    async closeFeedbackDialog() {
      this.setFeedbackDialogVisible(false)
    },
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}
.content {
  // display: grid;
  background: #fff;
  height: 100%;
  overflow-x: hidden;
}
.platform-g {
  top: 54px !important;
}
.space-text {
  height: 55px;
  cursor: pointer;
}
.space-text:hover {
  background: #d2d9e3;
  .space-name {
    color: #495f70 !important;
  }
}
.container {
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  .main-container {
    flex: 1;
  }
}
</style>
